module.exports = __webpack_public_path__ + "images/category_lp/macbook/main-view@2x_7634bf9b4362e4b85f59a91e5f6afe8d.png";